import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { MobileKalender } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile';
import { KalenderWeekPicker } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile/components/KalenderWeekPicker';
import { KalenderProvider } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile/KalenderContext';
import { faLayerGroup, faUserGroup } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/desktop/Grid';

/* eslint-disable max-lines-per-function */
export function MobilePage({ year, view }: { year: string; view: string }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <KalenderProvider year={year}>
      <div className="sticky top-0 z-10 bg-white">
        <KalenderWeekPicker />
      </div>
      <Tabs
        className="p-4"
        value={view}
        onValueChange={(value) => {
          navigate(`/mitarbeiter/rotationsplan/${year}/${value}`);
        }}>
        <div className="flex w-full justify-between">
          <TabsList className="w-full bg-neutrals-300">
            <TabsTrigger className="w-full" value="planung">
              {t('domain.mitarbeiter.rotationsplan.tabs.planung')}
            </TabsTrigger>
            <TabsTrigger disabled className="w-full" value="rotationsplaene">
              {t('domain.mitarbeiter.rotationsplan.tabs.rotationsplaene')}
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="planung">
          <Tabs
            className="flex flex-col gap-4"
            defaultValue="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
            <div className="flex justify-between items-center">
              <TabsList className="bg-neutrals-300">
                <Tooltip>
                  <TooltipTrigger>
                    <TabsTrigger value="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
                      <FontAwesomeIcon fixedWidth icon={faLayerGroup} />
                    </TabsTrigger>
                  </TooltipTrigger>
                  <TooltipContent>
                    {t(
                      'domain.mitarbeiter.rotationsplan.tabs.anzeigeNachArbeitsbereichenTooltip',
                    )}
                  </TooltipContent>
                </Tooltip>
                <Tooltip>
                  <TooltipTrigger>
                    <TabsTrigger value="mitarbeiter_rotationsplanKalenderByMitarbeiter">
                      <FontAwesomeIcon fixedWidth icon={faUserGroup} />
                    </TabsTrigger>
                  </TooltipTrigger>
                  <TooltipContent>
                    {t(
                      'domain.mitarbeiter.rotationsplan.tabs.anzeigeNachMitarbeitendenTooltip',
                    )}
                  </TooltipContent>
                </Tooltip>
              </TabsList>
            </div>
            <TabsContent
              asChild
              value="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
              <MobileKalender view="arbeitsbereiche" />
            </TabsContent>
            <TabsContent
              asChild
              value="mitarbeiter_rotationsplanKalenderByMitarbeiter">
              <MobileKalender view="mitarbeiter" />
            </TabsContent>
          </Tabs>
        </TabsContent>
        <TabsContent className="mt-8" value="rotationsplaene">
          <Grid />
        </TabsContent>
      </Tabs>
    </KalenderProvider>
  );
}
